import { IUser } from "@rentiohq/shared-frontend/dist/types/auth.types";
import {
  IFormikValues,
  IFormStep,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { uiSchema } from "./schema.profilePersonal";
import { getInitialValues } from "./schema.profilePersonal.utils";

export const profilePersonalSchema =
  (extraData: { user: IUser }) =>
  (): { formStepsSchema: IFormStep[]; initialValues: IFormikValues } => {
    const initialValues = getInitialValues(extraData.user);
    const formStepsSchema = [
      {
        uiSchema: uiSchema(),
      },
    ];

    // @ts-ignore
    return { formStepsSchema, initialValues };
  };
